import { Component, ElementRef, EventEmitter, Input, NgModule, OnInit, Output, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { CreateControlAccessProvider, WOption, WOptionOrString } from '@wipo/w-angular/shared';
import { FFacetInfoModule } from '@wipo/w-angular/internal';

import { WInputMulticolumns } from '@wipo/w-angular/shared';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'w-input-radio',
    templateUrl: './w-input-radio.component.html',
    providers: [CreateControlAccessProvider(WInputRadioComponent)],
    host: {
        class: 'b-input b-input-radio'
    },
    standalone: false
})
/*
@id w-input-radio
@name w-input-radio
@status release
@description
*/
export class WInputRadioComponent extends WInputMulticolumns implements OnInit {
  @ViewChildren('radio') radios!: QueryList<ElementRef>;

  @Input() horizontal: boolean = false; // display options horizontally
  @Input() options: (WOption | string)[] = []; // either array of options or strings
  valueIndex: number = -1;

  @Output() wClick = new EventEmitter<Event>(); // returns click event
  @Output() wChange = new EventEmitter<any>(); // emits value of selected option
  protected get childrenCount(): number {
    return this.options.length;
  }
  isOptionDisabled(option: WOptionOrString): boolean | null {
    const disabled = (typeof option !== 'string' && option?.disabled);
    return disabled ? true : null;
  }
  protected get childHeight() {
    if (this.radios?.length ?? 0 > 0) {
      const r = this.radios?.get(0)?.nativeElement?.getBoundingClientRect();
      return r?.height ?? 24;
    } else return 24;
  }
  // tslint:disable-next-line: variable-name
  constructor(protected _renderer: Renderer2, protected _elementRef: ElementRef) { super(); }
  getTitle(option: WOptionOrString) {
    if (typeof option === 'string') {
      return this.attr(option);
    } else {
      // if we use WOption array, we can set title for each option
      return this.attr(option?.tip);
    }
  }
  override ngOnInit(): void {
    super.ngOnInit();
    this.registerOnChange(this.initValue.bind(this));

    if (this.horizontal) {
      this.maxColumns = 1;
    }

  }

  initValue() {
    if (this.value === null || this.value === undefined || !Array.isArray(this.options)) {
      this.valueIndex = -1;
    } else if (this.options) {
      this.valueIndex = this.options.reduce((acc, o, i) => {
        return this.getValue(o) === this.value ? i : acc;
      }, -1);
    }
  }

  changeIndex(index: number) {
    this.valueIndex = index;
    this.value = this.getValue(this.options[index]);
    // do not trigger events manually
    // events get emited from (click) and (change) of input
  }
  clickIndex(i: number, option: WOptionOrString, event: MouseEvent): void {
    // emit events and update values (called from click on label)
    this.wClick.emit(event);
    if (!(this.disabled || (typeof option !== 'string' && option.disabled))) {
      this.changeIndex(i);
      this.wChange.emit(this.value)
    }
  }
}
@NgModule({
  imports: [CommonModule, FormsModule, FFacetInfoModule],
  exports: [WInputRadioComponent],
  declarations: [WInputRadioComponent]
})
export class WInputRadioModule { }
